<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="true">
</app-crudbar>
<div>
  <div class="w-full top-10 border-2  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border-1">
      <app-mtrpi01 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-mtrpi01>
    </div>
    }
  </div>
<div>
